import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=79667bf8&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79667bf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79667bf8')) {
      api.createRecord('79667bf8', component.options)
    } else {
      api.reload('79667bf8', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=79667bf8&scoped=true", function () {
      api.rerender('79667bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lifeImpact/IndexPage.vue"
export default component.exports